import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from './code-snippet.interface';


@Component({
    selector: 'show-formatted-snippet',
    template: '',
    standalone: false
})
export class ShowFrmtSnippet implements CodeSnippet{

    text : string = $localize`:@@script-editor.snippet.show-formatted:show formatted`;

    static category: string = 'common';

    data: any;

    part = true;

    insert(): string | Promise<string> {
        return `
    -- the first argument is the format string where placeholder are numbers in brackets
    -- as a zero-based index to the following arguments. if just brackets are needed to be
    -- shown in format string, use {{ and }} instead or use the overload with only the
    -- first string argument. additional information to further formatting options
    -- can be found here
    -- https://learn.microsoft.com/en-us/dotnet/fundamentals/runtime-libraries/system-string-format#get-started-with-the-stringformat-method
    show("A number: {0}, some string: {1}, some brackets: {{ }}", 123, 'Hallo')
`
    }
}